module.exports = __webpack_public_path__ + "img/outcome_02.51f5f078.png";